// @flow
import { useMemo } from 'react';
import values from 'ramda/es/values';
import reduce from 'ramda/es/reduce';

import { type RecipientsType } from './RecipientsTypes';


type Schools = {
  [key: string]: {
    id: number,
    title: string,
  }
}

export default function useActualSchoolsByRecipients(schools: Schools, recipients: RecipientsType): Schools {
  return useMemo(() => {
    const actualSchools = reduce((acc, { school_ids: ids }) => {
      const schoolsByIds = reduce((acc_, id) => (schools[id] ? {
        ...acc_,
        [id]: schools[id],
      } : acc_), {}, ids);

      return { ...acc, ...schoolsByIds };
    }, {}, values(recipients));

    return actualSchools;
  }, [recipients, schools]);
}
